import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config";
import { obtenerEstilo, ESTILO_POR_DEFECTO } from "../temas/catalogoEstilos";

const EstiloContext = createContext(null);
const EstiloServiciosContext = createContext(null);

export const EstiloProvider = ({ children }) => {
  const [estilo, setEstilo] = useState(ESTILO_POR_DEFECTO);
  const [estiloServicios, setEstiloServicios] = useState(ESTILO_POR_DEFECTO);

  useEffect(() => {
    const cargar = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/colores-sitio/efectivo`);
        setEstilo(obtenerEstilo(res.data?.estilo));
        setEstiloServicios(obtenerEstilo(res.data?.estiloServicios));
      } catch (err) {
        console.error("Error cargando estilo visual:", err);
      }
    };
    cargar();
  }, []);

  return (
    <EstiloContext.Provider value={estilo}>
      <EstiloServiciosContext.Provider value={estiloServicios}>
        {children}
      </EstiloServiciosContext.Provider>
    </EstiloContext.Provider>
  );
};

// Estilo GENERAL — el que heredan los servicios que no tienen uno propio.
// Fallback al estilo clásico si se usa fuera del provider.
export const useEstilo = () => {
  const ctx = useContext(EstiloContext);
  return ctx || ESTILO_POR_DEFECTO;
};

// Estilo, independiente del general, SOLO para la pantalla
// "Seleccione un Servicio".
export const useEstiloServicios = () => {
  const ctx = useContext(EstiloServiciosContext);
  return ctx || ESTILO_POR_DEFECTO;
};
